import React, { useEffect, useState } from 'react';
import { api } from '../shared/api';

// m.10.2 Bilanca ADO wizard. App servira twin (Neven, /rad/faros/task14/wizard/app/INTEGRACIJA.md);
// BIS izdaje potpisani token i ucitava app u fullscreen iframe. Novi token samo ponovnim otvaranjem modula.
export function BilancaWizardModule({ token, onClose }: { token: string | null; onClose: () => void }) {
    const [url, setUrl] = useState<string | null>(null);
    const [greska, setGreska] = useState<string | null>(null);

    useEffect(() => {
        let ziv = true;
        api<{ url: string }>('/bilanca/token', token)
            .then((r) => { if (ziv) setUrl(r.url); })
            .catch((e: unknown) => { if (ziv) setGreska(e instanceof Error ? e.message : String(e)); });
        return () => { ziv = false; };
    }, [token]);

    // Stranica ispod je na mobitelu sira od ekrana i vuce iframe u stranu; dok je wizard otvoren ne scrolla.
    useEffect(() => {
        const html = document.documentElement.style.overflow;
        const body = document.body.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        return () => {
            document.documentElement.style.overflow = html;
            document.body.style.overflow = body;
        };
    }, []);

    return (
        <div style={{ position: 'fixed', inset: 0, zIndex: 4000, background: '#fff', display: 'flex', flexDirection: 'column', width: '100vw', maxWidth: '100vw', overflow: 'hidden' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '4px 12px', borderBottom: '1px solid #ccc', fontSize: '0.85rem' }}>
                <strong>10.2 Bilanca ADO</strong>
                <button type="button" onClick={onClose} style={{ marginLeft: 'auto', padding: '2px 10px', cursor: 'pointer' }}>Zatvori</button>
            </div>
            {greska ? <p className="error" style={{ padding: 16 }}>{greska}</p> : null}
            {!greska && !url ? <p style={{ padding: 16 }}>Otvaram wizard...</p> : null}
            {url ? (
                <iframe
                    title="Bilanca ADO wizard"
                    src={url}
                    style={{ flex: 1, width: '100%', border: 0 }}
                    referrerPolicy="no-referrer"
                />
            ) : null}
        </div>
    );
}
